export default "__VITE_ASSET__CHpy3hDg__"